import { config, handleResponse } from '../../_helpers';

export const roleDetailService = {
    getAccessByMenuSet,
    getAccessByMenuId
};


function getAccessByMenuSet(roleId,menuSet) {
    const requestOptions = {
        method: 'GET'
    };
    
    return fetch(`${config.apiUrl}/RoleDetails/getAccessByMenuSet?roleId=${roleId}&MenuSet=${menuSet}`, requestOptions).then(handleResponse);
}

function getAccessByMenuId(roleId,menuId) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(menuId),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    
    // return fetch(`${config.apiUrl}/RoleDetails/getAccessByMenuId?roleId=${roleId}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/RoleDetails/getAccessByMenuIdV1?roleId=${roleId}`, requestOptions).then(handleResponse);
}